import { type MetaFunction } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { CarService } from '#app/entities/car/service.server.ts'
import { getMetaTags } from '#app/shared/lib/meta-tags.ts'
import { Spacer } from '#app/shared/ui/data-display/Spacer.tsx'
import Header from '#app/shared/ui/layout/Header.tsx'
import { CtaBanner } from './ui/CtaBanner'
import Hero from './ui/Hero'
import { Location } from './ui/Location'
import { Process } from './ui/Process'
import { Services } from './ui/Services'
import { Showroom } from './ui/Showroom'
import { SoldCars } from './ui/SoldCars'
import { Testimonials } from './ui/Testimonials'

export const meta: MetaFunction = ({ matches }) => {
  return getMetaTags({
    matches,
    title: 'Sobre Nosotros | Gama Óptima',
    description:
      'Descubre Gama Óptima: coches premium de ocasión reacondicionados con los más altos estándares. Selección nacional e internacional y entrega a domicilio.',
    url: 'https://gamaoptima.com/sobre-nosotros',
  })
}

export async function loader() {
  const carlist = await CarService.findMany({
    isReserved: false,
    where: {
      reservation: {
        isPurchaseCompleted: true,
        updatedAt: { gte: CarService.getSoldGraceThresholdDate() },
      },
    },
    orderBy: {
      reservation: { updatedAt: 'desc' },
    },
    limit: 8,
    select: {
      id: true,
      slug: true,
      model: true,
      description: true,
      year: true,
      matriculation: true,
      mileage: true,
      horsePower: true,
      transmission: true,
      fuelType: true,
      price: true,
      discount: true,
      minFinancedAmount: true,
      minMonthlyPayment: true,
      brand: { select: { name: true } },
      images: {
        select: { id: true },
        take: 1,
      },
      reservation: {
        select: { id: true, isPurchaseCompleted: true },
      },
    },
  })

  return {
    carlist,
  }
}

export default function SobreNosotros() {
  const { carlist } = useLoaderData<typeof loader>()
  return (
    <>
      <Header isSticky={true} showBanner={true} />
      <div className="bg-neutral-25">
        <Hero />
        <Spacer size="16px" sizeMd="24px" />
        <Services />
        <Process />
        <Showroom />
        <Testimonials />
        <SoldCars carlist={carlist} />
        <Location />
        <CtaBanner />
      </div>
    </>
  )
}
